import React from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';

interface WorkflowMessageHeaderProps {
  messageText: string;
  tooltip: string;
  showChevron: boolean;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
}

export const WorkflowMessageHeader = ({
  messageText,
  tooltip,
  showChevron,
  isCollapsed,
  onToggleCollapsed,
}: WorkflowMessageHeaderProps) => {
  const intl = useIntl();

  return (
    <Layout align="center">
      <Layout ml="-3px" alignSelf="flex-start">
        <Tooltip tooltip={tooltip} placement="left">
          <Icon
            name="evisort-ai-animated"
            size="ml"
            icon="evisort-ai-animated"
          />
        </Tooltip>
      </Layout>
      <Layout pl="13px" direction="column" w="100%" spacing={2}>
        <Layout direction="row" align="center" spacing={2}>
          <Text color="status.active" variant="body" fontWeight="medium">
            {messageText}
          </Text>
          {showChevron && (
            <Layout
              cursor="pointer"
              onClick={onToggleCollapsed}
              title={
                isCollapsed
                  ? intl.formatMessage({
                      id: 'WorkflowRoutingAgent.expand',
                      defaultMessage: 'Expand',
                      description: 'Expand thinking messages',
                    })
                  : intl.formatMessage({
                      id: 'WorkflowRoutingAgent.collapse',
                      defaultMessage: 'Collapse',
                      description: 'Collapse thinking messages',
                    })
              }
            >
              <Icon
                icon={isCollapsed ? 'chevron-right' : 'chevron-down'}
                size="s"
                color="status.active"
              />
            </Layout>
          )}
        </Layout>
      </Layout>
    </Layout>
  );
};
